<template>
<v-app id="inspire" :height="heightApp" :width="widthApp">
     <v-content style="z-index:2" height="0">
          <v-container class="fill-height text-center">
               <v-row>
                    <v-col>
                         <v-card>
                              <v-toolbar height="80" :style="'background:'+(settings[0] ? settings[0].color : '#2F839D')" class="">
                                   <!-- <img src="../../assets/logo.png" width="20%" class="imgLogo" /> -->
                                   <span class="controlLogin">{{ $t('login') }}</span>

                              </v-toolbar>
                              <v-card-text>
                                   <v-form class="mt-4">
                                        <v-text-field class="mx-8 mt-12" height="" :color="(settings[0] ? settings[0].color : '#2F839D')" outlined dense label="Login" name="login" clearable v-model="form.n_labo" prepend-icon="mdi-account" type="text" />
                                        <v-text-field class="mx-8" id="password" :color="(settings[0] ? settings[0].color : '#2F839D')" outlined dense label="Password" clearable v-model="form.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" name="password" @click:append="show1 = !show1" prepend-icon="mdi-lock" :type="show1 ? 'text' : 'password'" />
                                   </v-form>
                              </v-card-text>
                              <!-- <a class="mx-6" href="#">{{ $t('forgetPass') }}</a><br> -->
                              <v-btn class="py-5 mt-9" width="80%" :color="(settings[0] ? settings[0].color : '#2F839D')" dark @click="login">{{ $t('login') }}</v-btn>
                              <v-card-actions class="mt-3">
                                   <!-- <v-spacer /> -->
                              </v-card-actions>
                         </v-card>
                    </v-col>
               </v-row>
          </v-container>
     </v-content>
     <v-overlay :value="true" :z-index="0">
     </v-overlay>
     <v-overlay :value="isLoading">
          <v-progress-circular indeterminate size="80"></v-progress-circular>
     </v-overlay>

</v-app>
</template>

<script>
export default {

     data() {
          return {
               isLoad: false,
               heightApp: window.innerHeight,
               widthApp: window.innerWidth,
               absolute: true,
               opacity: 0.46,
               overlay: true,
               zIndex: 0,
               show1: false,
               form: {
                    password: "",
                    n_labo: "",
                    domainName: document.location.origin,
               }
          }
     },
     methods: {
          login() {
               this.isLoad = true
               this.$store.dispatch('login', this.form).then((r) => {
                    this.isLoad = false 
                    setTimeout(() => {
                         location.reload()
                    }, 6000);
               }).catch((e) => {
                    this.isLoad = false
               })
          },
     },
     computed: {
          isLoading() {
               return this.$store.state.isLoadings
          },

     },
     created() {
          window.addEventListener('resize', () => {
               this.heightApp = window.innerHeight
               this.widthApp = window.innerWidth
          })
     }
}
</script>

<style scoped>
#inspire {
     background-image: url('../../assets/lifeline2.gif');
     background-repeat: no-repeat;

     background-attachment: fixed;
     background-size: 100% 100%;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
     margin: 0 auto;
     height: 450px;
     width: 500px;
}

.v-toolbar__content,
.v-toolbar__extension {
     height: 0 !important;
     /* margin-left: 50px; */
}

.toolBarImg {
     border: 2px bold #fff !important;
}

.controlLogin {
     position: absolute;
     color: #fff;
     left: 40%;
     font-size: 40px;
     font-weight: bold;
}
</style>
